import React, { Component } from 'react'
import { Routes, Route } from 'react-router-dom'

import endPoints from '../../components/Consts/endPoints.json'

import { Programs, ProgramsForm } from '../../views/Programs'

export default class ProgramsRoute extends Component {
  render () {
    var releatedRoutes = endPoints.find(aa => aa.name == 'Programs')?.routes
    return (
      <Routes>
        <Route path={releatedRoutes?.get} exact element={<Programs />} />
        <Route path={releatedRoutes?.create} exact element={<ProgramsForm />} />
        <Route path={releatedRoutes?.update} exact element={<ProgramsForm />} />
        <Route path={releatedRoutes?.delete} exact element={<ProgramsForm />} />
      </Routes>
    )
  }
}
